/* eslint-disable import/no-default-export */
import classNames from 'classnames';
// eslint-disable-next-line no-restricted-imports
import RouterLink from 'common/components/singlespa/router-link';
// eslint-disable-next-line no-restricted-imports
import { State } from 'modules';
import React from 'react';
import { connect } from 'react-redux';
// eslint-disable-next-line no-restricted-imports
import { isNavigating } from 'selectors';
import styles from './header.less';

interface StateProps {
  isNavigating: boolean;
}

interface Props extends StateProps {
  className?: string;
  preventDefault?: boolean;
}

class HeaderLogo extends React.Component<Props> {
  render() {
    const classes = classNames(
      styles.logo,
      window.location.host !== 'trello.com' && styles.gammaLogo,
      this.props.className,
      this.props.isNavigating && styles.throbbing,
    );

    return (
      <RouterLink
        href="/"
        className={classes}
        preventDefault={this.props.preventDefault}
      >
        <span className={styles.loadingLogo} />
        <span className={styles.defaultLogo} />
      </RouterLink>
    );
  }
}

function mapStateToProps(state: State) {
  return {
    isNavigating: isNavigating(state),
  };
}

export default connect(mapStateToProps)(HeaderLogo);



// WEBPACK FOOTER //
// ./app/gamma/src/components/header/header-logo.tsx